import {useAuthContext} from "../../../Auth/provider/AuthProvider";
import MissionsFilter from "./components/filter";
import MissionsGridList from "./components/grid-list";
import __ from "../../../../core/utils/translate/translate";
import {getActiveOrganisation} from "../../../Auth/services/organisationService";

const MissionsMissions = () => {
    const {organisation} = useAuthContext();

    return (
        <div className="flex flex-col gap-8">
            {/*<RenderIf cond={!!organisation}>*/}
            {/*    <div className="-mx-4">*/}
            {/*        <MissionsHorizontalList/>*/}
            {/*    </div>*/}
            {/*</RenderIf>*/}

            <div className="xl:px-52">
                <MissionsFilter title={!!getActiveOrganisation() ? 'ماموریت‌های کانون' : __("Nojahan missions")}/>
            </div>

            <div className="flex flex-col gap-4 xl:px-52">
                <MissionsGridList commonGame={!getActiveOrganisation()}/>
            </div>
        </div>
    );
};

export default MissionsMissions;
